<style scoped lang="scss">
.state {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}

._printContent /deep/ .el-form-item__label {
  text-align: right;
  vertical-align: middle;
  font-size: 22px;
  color: black;
  padding: 0 10px 0 0;
  box-sizing: border-box;
  font-family: '微软雅黑';
}

._printContent /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: black;
  display: inline-block;
  font-size: 22px;
  outline: none;
  padding: 0 10px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 130px;
  line-height: 25px;
  height: 25px;
  font-family: '微软雅黑';
}
.custom-input-width /deep/ .el-input__inner {
  width: 90px;
}

._printContent /deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 8px;
  line-height: 25px;
}

._printContent /deep/ .el-date-editor,
form .el-input,
form .el-select,
form .el-textarea {
  min-width: 130px;
  width: 100%;
}

._printContent /deep/ .el-input {
  width: 130px;
}

._printContent_long /deep/ .el-input {
  width: 395px;
}

._printContent_long /deep/ .el-input__inner {
  width: 395px;
  line-height: 25px;
  height: 25px;
  font-size: 22px;
  font-family: '微软雅黑';
  color: black;
  background-color: #fff;
  padding: 0 10px;
}

.printFontFamily {
  font-family: '微软雅黑';
}
</style>
<style>
.weier-dialog .el-dialog {
  .el-dialog__body {
    max-height: none;
  }
}

.standard-print-dialog .el-dialog {
  .el-dialog__body {
    max-height: none;
  }
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/weier/process/wo/page" getKey="rows" :columns="columns" :isExpand="true">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanxian')">
            <el-select v-model="yt.conditions.equipmentIdList" :multiple="true">
              <el-option style="width: 350px" v-for="(item,index) in productionList" :label="item.labelName" :value="item.id"></el-option>
            </el-select>
<!--            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"></yi_data_select>-->
          </el-form-item>
          <el-form-item :label="$t('zhichenggongyi')">
            <yi_dictionary_select :clearable="false" :showOptionIds="['02', '03', '04']" :max="8" multiple :type="'MANUFACTURING_PROCESS'" :ids.sync="yt.conditions.manufacturingProcessList"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('gongdanzhuangtai')">
            <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="yt.conditions.statusList"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jihuakaishishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planStartTimeStart" :end.sync="yt.conditions.planStartTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jihuawanchengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planEndTimeStart" :end.sync="yt.conditions.planEndTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shijiwanchengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.actualEndTimeStart" :end.sync="yt.conditions.actualEndTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('erpwuliaobianma')">
            <el-input v-model="yt.conditions.erpMaterialCode"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ statusList: ['2', '3', '4', '5'], manufacturingProcess: '',manufacturingProcessList: ['02','03','04'], orderBy: 'planStartTime,equipmentId asc' })">
              {{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <div class="state">
          <div class="state">
            <span style="width: 12px;height: 12px;border-radius: 50%;background-color: #67C23A;"></span>
            <span style="margin-left: 5px; font-size:12px">{{ $t('zhuchanpin') }}</span>
          </div>
          <div class="state" style="margin-left: 32px;">
            <span style="width: 12px;height: 12px;border-radius: 50%;background-color: #F0C78A;"></span>
            <span style="margin-left: 5px;font-size:12px">{{ $t('fuchanpin') }}</span>
          </div>
        </div>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="yt.exportLoading" @click="exportExcel()" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-导出' } }"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #shengchangongdanhao="scope">
        <div style="display: flex;flex-wrap: nowrap;justify-content: flex-start;align-items: center;">
          <div v-if="scope.row.parentId == null" style="float:left;width: 8px;height: 8px;border-radius: 50%;background-color: #67C23A;"></div>
          <div v-if="!(scope.row.parentId == null)" style="float:left;width: 8px;height: 8px;border-radius: 50%;background-color: #F0C78A;"></div>
          <span style="margin-left: 10px;">{{ scope.row.no }}</span>
        </div>
      </template>
      <!-- 工艺指南编码 -->
      <template #gongyizhinanbianma="scope">
        <span>{{ scope.row.woProcedureList | getCode }}</span>
      </template>
      <template #expand="scope">
        <sub_list :sub="scope.row.woProcedureList" :all="scope.row" :status="scope.row.status" :equipmentId="scope.row.equipmentId"></sub_list>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('gongdanBOM', scope.row, 'w2')" v-if="utils.checkPower('web_production_management_wo_bom_page')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-工单BOM' } }">
              {{ $t('gongdanBOM') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="loading" v-if="utils.checkPower('web_production_management_custom_wo_close') && (scope.row.status == 1 || scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 2)" type="text" class="font-color-danger" @click="close(scope.row)">{{ $t('guanbi') }} </el-button>
          </el-col>
          <!-- 状态  1新建、2发放、3生产中、4暂停、5首工序完工、6完工、7关闭、8已调拨 -->
          <el-col :span="0.1">
            <el-button :loading="loading" v-if="(scope.row.status == 2 || scope.row.status == 4) && scope.row.parentId == null && utils.checkPower('web_production_management_wo_start')" type="text" @click="woCheck(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-开始' } }">{{ $t('kaishi') }} </el-button>
          </el-col>
          <el-col :span="0.1"><!-- 副工单开始 -->
            <el-button :loading="loading" v-if="scope.row.status == 4 && scope.row.parentId != null && scope.row.parentStatus == 6 && utils.checkPower('web_production_management_child_wo_start')" type="text" @click="childWoCheck(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-副工单开始' } }">{{ $t('kaishi') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.status == 3 && scope.row.parentId == null && utils.checkPower('web_production_management_wo_stop')" type="text" :loading="scope.row.stopLoading" @click="stop(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-暂停' } }">
              {{ $t('zanting') }}
            </el-button>
          </el-col>
          <el-col :span="0.1"><!-- 副工单暂停 -->
            <el-button v-if="scope.row.status == 3 && scope.row.parentId != null && scope.row.parentStatus == 6 && utils.checkPower('web_production_management_child_wo_stop')" type="text" :loading="scope.row.stopLoading" @click="childStop(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-副工单暂停' } }">
              {{ $t('zanting') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_production_management_work_order_execution_get_report_record') && (scope.row.status == 3 || scope.row.status == 4 || scope.row.status == 6 || scope.row.status == 5 || scope.row.status == 7 || scope.row.status == 8)" type="text" @click="yt.showEditDialog('baogongjilu', scope.row, 'w2')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-报工记录' } }">{{ $t('baogongjilu') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="(scope.row.status == 4 || scope.row.status == 2) && scope.row.parentId == null && utils.checkPower('web_production_management_wo_allot')" type="text" @click="allot(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-调拨' } }">
              {{ $t('diaobo') }}
            </el-button>
          </el-col>
          <!-- 打印标签(丝印) -->
          <el-col v-if="utils.checkPower('web_production_management_wo_printSilkLabel_weier') && scope.row.manufacturingProcess == '03'" :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-维尔打印标签(丝印)' } }">
            <el-button type="text" @click="weierPrintSilkLabel(scope.row)">
              {{ $t('dayinbiaoqian(siyin)') }}
            </el-button>
          </el-col>
          <!-- 打印标签(组装) -->
          <el-col v-if="utils.checkPower('web_production_management_wo_printAssembleLabel_weier') && scope.row.manufacturingProcess == '04'" :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-维尔打印标签(组装)' } }">
            <el-button type="text" @click="weierPrintAssembleLabel(scope.row)">
              {{ $t('dayinbiaoqian(zuzhuang)') }}
            </el-button>
          </el-col>
          <!-- 打印标签(加工) -->
          <el-col v-if="utils.checkPower('web_production_management_wo_printProcessLabel_weier') && scope.row.manufacturingProcess == '02'" :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-维尔打印标签(加工)' } }">
            <el-button type="text" @click="weierPrintProcessLabel(scope.row)">
              {{ $t('dayinbiaoqian(jiagong)') }}
            </el-button>
          </el-col>
          <!-- 适配工装(维尔) -->
          <el-col v-if="utils.checkPower('web_production_management_wo_adapt_tool_weier')" :span="0.1" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-适配工装' } }">
            <el-button type="text" @click="weierAdaptTool(scope.row)">
              {{ $t('shipeigongzhuang') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'baogongjilu'">
        <div class="dialog-scroller">
          <report :reportWork="yt.editObj" :chart="yt.editObj"></report>
        </div>
      </template>
      <template v-if="yt.editObj.action == 'gongdanBOM'">
        <div class="dialog-scroller">
          <bom :bomWork="yt.editObj"></bom>
        </div>
      </template>
      <template v-if="yt.editObj.action == 'diaobo'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('shengchangongdanhao')" required>
            <el-input disabled v-model="yt.editObj.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
            <yi_cross_select disabled multiple :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"></yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuashuliang')" required>
            <el-input disabled v-model="yt.editObj.planQuantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
            <el-input disabled v-model="yt.editObj.leftProductionQuantity"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required>

            <el-select v-model="yt.editObj.equipmentId" :multiple="false" :mouldId="yt.editObj.mouldId" :materialId="yt.editObj.materialId">
              <el-option style="width: 350px" v-for="(item,index) in productionList" :label="item.labelName" :value="item.id"></el-option>
            </el-select>
<!--            <yi_cross_select :max="1" :component="'web_production_management_work_order_execution_equipment_list'" :ids.sync="yt.editObj.equipmentId" :mouldId="yt.editObj.mouldId" :materialId="yt.editObj.materialId"></yi_cross_select>-->
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <!--          id=yt.editObj.id;equipmentId=yt.editObj.equipmentId;mouldId=yt.editObj.mouldId;yt.req('POST','/web/production/wo/allot')-->
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="allocation" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'chaidan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('chanpinbianma')">
            <el-input disabled v-model="yt.editObj.material.code"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinmingcheng')">
            <el-input disabled v-model="yt.editObj.material.name"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuashuliang')">
            <el-input disabled v-model="yt.editObj.planQuantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengchanshuliang')">
            <el-input disabled v-model="yt.editObj.productionQuantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
            <el-input disabled v-model="yt.editObj.leftProductionQuantity"></el-input>
          </el-form-item>
          <div style="margin-left: 80px" v-for="(item, index) in yt.editObj.quantities" :key="index">
            <el-form-item>
              <span>{{ $t('shuliang') }}</span>
              <el-input-number style="width:20%;margin-right:10px;margin-left: 10px" v-model="item.quantitiesLable" :min="1"></el-input-number>
              <i class="el-icon-delete" @click="del(index)"></i>
            </el-form-item>
          </div>
          <el-button style="margin-left: 80px" type="text" icon="el-icon-circle-plus-outline" @click="add">
            {{ $t('zengjiayitiaochaidan') }}
          </el-button>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <!--          id=yt.editObj.id;equipmentId=yt.editObj.equipmentId;mouldId=yt.editObj.mouldId;yt.req('POST','/web/production/wo/allot')-->
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="split" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!--修改模腔数-->
      <template v-if="yt.editObj.action == 'xiugaimoqiangshu'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('lilunmoqiangshu')" required>
            <el-input disabled v-model="yt.editObj.cavity"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shijimoqiangshu')" required="required" label-width="145px">
            <el-input-number v-model="yt.editObj.actualCavity" @change="cavityChange" controls-position="right" :min="1" :max="cavityValue"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" :disabled="cavityDisabled" @click="yt.req('POST', '/web/production/wo/updateActualCavity')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'danjitiaozheng'">
        <div class="dialog-scroller">
          <singleAdjust ref="singleAdjust" @list-change="singleAdjustListChange"></singleAdjust>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" :disabled="singleAdjustList == null || singleAdjustList.length === 0" @click="batchSetPriority" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- equipmentId: 8998 leftProductionQuantity: 2 materialId: 23289 mouldId: 400 planQuantity: 2 woIds: [897] -->

      <template v-if="yt.editObj.action == 'piliangdiaobo'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('shengchangongdanhao')" required>
            <yi_cross_select ref="eqCS" :beforeSave="beforeSave" multiple :selectTitle="'no'" :component="'web_production_management_work_order_execution_batch_transfer'" :ids.sync="yt.editObj.ids"></yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
            {{ yt.editObj.materialStr }}
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuashuliang')" required>
            <el-input disabled v-model="yt.editObj.planQuantity"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengyushengchanshuliang')">
            <el-input disabled v-model="yt.editObj.leftProductionQuantity"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mojubianhao/mingcheng')" required>
            <el-select :clearable="true" v-model="yt.editObj.mouldId" :placeholder="$t('qingxuanze')" @change="
      yt.editObj.equipmentId = null;
    getAdaptEquipment();
    ">
              <el-option v-for="(mould, index) in adaptMoulds" :key="mould.no" :label="mould.no + '/' + mould.name" :value="mould.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required>
            <el-select :disabled="yt.editObj.mouldId == null || yt.editObj.mouldId == ''" :clearable="true" v-model="yt.editObj.equipmentId" :placeholder="$t('qingxuanze')">
              <el-option v-for="(equipment, index) in adaptEqs" :key="equipment.id" :label="equipment.name" :value="equipment.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/custom/qunlong/batchAllot')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-批量调拨' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 批量调整 -->
    <batchAdjust :show.sync="show" />
    <!-- 批量导入排产 -->
    <batchImportScheduling :show.sync="batchImportSchedulingShow" />
    <!-- 打印标签(丝印) -->
    <el-dialog class="weier-dialog" :visible.sync="isShowWeierPrintSilkLabel" append-to-body="append-to-body" width="800px">
      <weierSilkLabel v-if="isShowWeierPrintSilkLabel" :printObj="printObj" @closeDialog="closeWeierPrintSilkLabel"></weierSilkLabel>
    </el-dialog>
    <!-- 打印标签(组装) -->
    <el-dialog class="weier-dialog" :visible.sync="isShowWeierPrintAssembleLabel" append-to-body="append-to-body" width="800px">
      <weierAssembleLabel v-if="isShowWeierPrintAssembleLabel" :printObj="printObj" @closeDialog="closeWeierPrintAssembleLabel"></weierAssembleLabel>
    </el-dialog>
    <!-- 打印标签(加工) -->
    <el-dialog class="weier-dialog" :visible.sync="isShowWeierPrintProcessLabel" append-to-body="append-to-body" width="800px">
      <weierProcessLabel v-if="isShowWeierPrintProcessLabel" :printObj="printObj" @closeDialog="closeWeierPrintProcessLabel"></weierProcessLabel>
    </el-dialog>
    <!-- 适配工装(维尔) -->
    <el-dialog :title="$t('chanpinshipeigongzhuang')" :visible.sync="isShowWeierAdaptTool" append-to-body="append-to-body" width="800px">
      <div class="dialog-scroller">
        <weierAdaptTool v-if="isShowWeierAdaptTool" :material="material"></weierAdaptTool>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue';

import sub_list from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/sub/list';
import report from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/report';
import bom from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/bom';
import batchAdjust from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/batch_adjust';
import singleAdjust from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/single_adjust';
import batch_transfer from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/batch_transfer';
import batchImportScheduling from '@@/pages/web/order_management/production_plan/batch_import_scheduling';
import standardPrintLabel from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/standard_print_label';
import weierSilkLabel from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/weier_silk_label';
import weierAssembleLabel from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/weier_assemble_label';
import weierProcessLabel from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/weier_process_label';
import weierAdaptTool from '@@/pages/web/customize/weier/screen_printing_management/work_order_execution/weier_adapt_tool';
import VueQr from 'vue-qr';

Vue.component('web_screen_printing_management_work_order_execution_batch_transfer', batch_transfer);

export default {
  name: 'web_screen_printing_management_work_order_execution_list',
  components: {
    sub_list,
    report,
    bom,
    batchAdjust,
    singleAdjust,
    batchImportScheduling,
    standardPrintLabel,
    weierSilkLabel,
    weierAssembleLabel,
    weierProcessLabel,
    weierAdaptTool,
    VueQr
  },
  data() {
    return {
      productionList:[],
      jinlingReportLoading:false,
      show: false,
      batchImportSchedulingShow: false,
      loading: false,
      zhongshuoSapLoading: false,
      cavityNumber: '',
      initialInputValue: '',
      cavityDisabled: true,
      fildIds: '',
      material: null,
      clampingtimes: null,
      isShowWeierPrintSilkLabel: false,
      isShowWeierPrintAssembleLabel: false,
      isShowWeierPrintProcessLabel: false,
      isShowWeierAdaptTool: false,
      printObj: {},
      singleAdjustList: [],
      //机模配信息
      adaptMoulds: [],
      adaptEqs: [],
      colorNoEnable: false,
      columns: [
        {
          label: 'zhichenggongyi',
          prop: 'manufacturingProcess',
          type: 'dictionary',
          key: 'MANUFACTURING_PROCESS',
          width: 80
        },
        {
          label: 'shengchangongdanhao',
          prop: 'no',
          type: 'slot',
          sort: 'string',
          width: 180
        },
        {
          label: 'jihuadanhao',
          prop: 'plan.no',
          sort: 'string',
          width: 160
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          sort: 'string',
          width: 160
        },
        {
          label: 'guishuchejian',
          prop: 'org.name',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          sort: 'string',
          width: 160
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          sort: 'string',
          width: 160
        },
        {
          label: 'chanxian',
          prop: 'equipment.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'planQuantity',
          sort: 'number',
          width: 110
        },
        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          sort: 'string',
          prop: 'status',
          width: 120,
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          }
        },
        {
          label: 'jihuakaishishijian',
          prop: 'planStartTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'jihuawanchengshijian',
          prop: 'planEndTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'shijikaishishijian',
          prop: 'actualStartTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'shijiwanchengshijian',
          prop: 'actualEndTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          sort: 'string',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'shijimoqiangshu',
          prop: 'actualCavity',
          width: 130
        },
        {
          label: 'chanpinguige',
          prop: 'material.spec',
          sort: 'string',
          width: 130
        },
        {
          label: 'sehao',
          prop: 'plan.colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 130
        },
        {
          label: 'shengchanshuliang',
          prop: 'productionQuantity',
          width: 130
        },
        {
          label: 'shengyushengchanshuliang',
          prop: 'leftProductionQuantity',
          width: 130
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'finishGoodQuantity',
          width: 130
        },

        {
          label: 'yibaogongbuliangpinshu',
          prop: 'finishBadQuantity',
          width: 130
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'biaozhunzhouqi(miao/mu)',
          prop: 'standardCycle',
          width: 130
        },
        {
          label: 'shougongxuwanchengshijian',
          prop: 'firstProcessFinishTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'wangongyuceshijian',
          prop: 'preFinishTime',
          type: 'time',
          width: 180
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'shengyushijian(xiaoshi)',
          prop: 'leftHours',
          width: 130
        },
        {
          label: 'gongyizhinanbianma',
          prop: 'craftGuide.code',
          // type: 'slot',
          width: 130
        },
        {
          label: 'huohao',
          prop: 'plan.articleNumber',
          width: 150
        },
        {
          label: 'shengchandingdanfenluid',
          prop: 'plan.orderEntryId',
          width: 150
        },
        {
          label: 'gongdanshunxu',
          prop: 'priority',
          width: 130
        },
        {
          label: 'shifoujiaji',
          prop: 'urgent',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'erpwuliaobianma',
          prop: 'material.erpMaterialCode',
          width: 130
        },
        {
          label: 'beizhu',
          prop: 'remark'
          // width: 130,
        },
        {
          label: 'yidayinshuliang',
          prop: 'printCountNum'
        },
        {
          label: 'shengyudayinshuliang',
          prop: 'leftPrintCountNum'
        },
        {
          label: 'kehubianma',
          prop: 'plan.wmsCustomerCode',
          sort: 'string',
          width: 130
        },
        {
          label: 'kehumingcheng',
          prop: 'plan.wmsCustomerName',
          sort: 'string',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  filters: {
    getCode(value) {
      if (value != null) {
        return value
          .map(item => {
            return item.procedureCode;
          })
          .join(',');
      }
      return '';
    }
  },
  watch: {
    'yt.conditions.manufacturingProcessList': {
      handler(n, o) {
        if(n === null || n.length === 0){
          this.$nextTick(()=>{
            this.yt.conditions.manufacturingProcessList = o;

          })
        }
      },
      immediate: false,
      deep: true
    },
    'yt.editObj.action': {
      handler(n, o) {
        if (n == 'xiugaimoqiangshu') {
          this.initialInputValue = this.yt.editObj.actualCavity;
          // console.log('this.initialInputValue', this.initialInputValue)
        }
      },
      immediate: false,
      deep: true
    },
    cavityNumber: {
      handler(n, o) {
        if (n == this.initialInputValue) {
          this.cavityDisabled = true;
        }
      },
      immediate: false,
      deep: true
    }
  },
  computed: {
    cavityValue() {
      return this.yt.editObj.cavity;
    }
  },
  created() {
    this.getProductionConfig();
    setTimeout(() => {
      this.yt.conditions = {
        statusList: ['2', '3', '4', '5'],
        manufacturingProcess: '',
        manufacturingProcessList: ['02','03','04'],
        orderBy: 't.priority,t.planStartTime,t.equipmentId asc'
      };
      this.yt.get(1);
      this.utils.event_hub.$on('WEB_WORK_ORDER_EXECUTION_REFRESH', () => {
        this.yt.get();
      });
      this.getProcessEquipmentList();
      //默认隐藏
      this.yt.setColumnsHide(['shijikaishishijian','shijiwanchengshijian','mujubianhao','mujumingcheng','shijimoqiangshu','chanpinguige','sehao','shengchanshuliang','shengyushengchanshuliang','yibaogongliangpinshu','yibaogongbuliangpinshu','chuangjianshijian','biaozhunzhouqi(miao/mu)','shougongxuwanchengshijian','wangongyuceshijian','shengyushijian(xiaoshi)','gongyizhinanbianma','huohao','shengchandingdanfenluid','gongdanshunxu','shifoujiaji','erpwuliaobianma','beizhu','yidayinshuliang','shengyudayinshuliang','kehubianma','kehumingcheng']);
    }, 300);
  },
  destroyed() {
    // 取消对bus事件的监听
    this.utils.event_hub.$off('WEB_WORK_ORDER_EXECUTION_REFRESH');
  },
  methods: {
    getProcessEquipmentList(){
      this.http.get('/custom/weier/process/plan/getProcessEquipmentList').then((res) => {
        this.productionList = res.data;
        for(let i=0;i<this.productionList.length;i++){
          const labelName = this.productionList[i]['name']+' | '+this.productionList[i]['sn']
          this.$set(this.productionList[i],'labelName',labelName)
        }
        // this.utils.successMessage(res.msg)
      }).catch((msg) => {
        this.utils.errorMessage(msg);
      });
    },
    colseForm(val){
      console.log('bbbbbbbbbbbbbbbbbb',val)

    },
    // 关闭工单
    close(row) {
      this.$confirm(this.$t('shiofouguanbi?'), this.$t('guanbiqueren'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      }).then(() => {
        this.loading = true;
        return this.http
          .post('/web/production/wo/close', { id: row.id })
          .then(res => {
            this.yt.get(1);
            this.$message.success(this.$t(res.msg));
          })
          .catch(error => {
            this.$message.error(this.$t(error));
          })
          .finally(() => {
            this.loading = false;
          });
      }).catch(() => {});
    },
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumn('sehao');
        }
      });
    },
    // 显示指定列
    showColumn(label) {
      for (let i = 0; i < this.columns.length; i++) {
        const c = this.columns[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    runJinlingAutoWorkOrdersJobRetry() {
      this.jinlingReportLoading = true;
      this.http.get('/custom/jinling/wo/autoWoReport')
            .then(res => {
              this.$message.success(this.$t('success'));
              this.jinlingReportLoading = false;
            })
            .catch(err => {
              this.jinlingReportLoading = false;
              this.$message.error(this.$t(err));
            });
    },
    runSyncWorkOrdersJobRetry() {
      this.$confirm(this.$t('shifoulijikaishixiufushuju'), this.$t('WARNING'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      })
        .then(() => {
          this.http
            .post('/custom/qunlong/work/orders/runSyncWorkOrdersJobRetry')
            .then(res => {
              this.$message.success(this.$t('kaishixiufushuju'));
            })
            .catch(err => {
              this.$message.error(this.$t(err));
            });
        })
        .catch(e => {
          this.$message.info(this.$t('yiquxiao'));
        });
    },
    cavityChange(value) {
      // console.log('value',this.initialInputValue);
      if (value) {
        this.cavityDisabled = false;
      }
      this.cavityNumber = value;
    },
    // beforeGet(params) {
    //   params['orderBy'] = 'planStartTime,equipmentId asc'
    //   // params['statusList'] = ['2','3','4','5']
    //   return params
    // },
    async allocation() {
      let params = {
        id: this.yt.editObj.id,
        equipmentId: this.yt.editObj.equipmentId,
        mouldId: this.yt.editObj.mouldId
      };
      return await this.http
        .post('/web/production/wo/allot', params)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.get();
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    woCheck(row) {
      let params = {};
      params.id = row.id;
      this.loading = true;
      this.http
        .post('/web/production/wo/check', params)
        .then(res => {
          this.loading = false;
          if (res.data == true) {
            this.start(row);
          } else {
            this.$confirm(this.$t('cunzaizantinggongdandetishi'), this.$t('tishi'), {
              confirmButtonText: this.$t('rengjixukaishi'),
              cancelButtonText: this.$t('quxiaokaishi'),
              type: 'warning'
            })
              .then(() => {
                this.start(row);
              })
              .catch(() => { });
          }
        })
        .catch(err => {
          this.loading = false;
          this.utils.errorMessage(err);
        });
    },
    start(row) {
      return this.http
        .post('/web/production/wo/start', row.id)
        .then(res => {
          this.yt.get();
          this.$message.success(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    stop(row) {
      this.$set(row, 'stopLoading', true);

      this.http
        .post('/web/production/wo/stopCheck', row.id)
        .then(res => {
          if (res.data && res.data > 0) {
            this.$confirm(this.$t('dqkhmcs') + res.data + ',' + this.$t('qqrsfjxzt') + '?', this.$t('tishi'), {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              return this.http
                .post('/web/production/wo/stop', row.id)
                .then(res => {
                  this.yt.get();
                  this.$message.success(this.$t(res.msg));
                })
                .catch(error => {
                  this.$message.error(this.$t(error));
                });
            });
          } else {
            return this.http
              .post('/web/production/wo/stop', row.id)
              .then(res => {
                this.yt.get();
                this.$message.success(this.$t(res.msg));
              })
              .catch(error => {
                this.$message.error(this.$t(error));
              });
          }
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.$set(row, 'stopLoading', false);
        });
    },
    allot(row) {
      this.yt.showEditDialog('diaobo', row, 'w1');
    },
    modify(row) {
      this.yt.showEditDialog('xiugaimoqiangshu', row, 'w1');
    },
    beforeShowSplitDialog(editObj) {
      if (editObj.action === 'chaidan') {
        editObj.quantities = [
          {
            quantitiesLable: ''
          }
        ];
      }
      return editObj;
    },
    // 添加按钮
    add() {
      // this.array.push(1)  //通过添加array的值，增加input的个数
      this.yt.editObj.quantities.push({
        quantitiesLable: ''
      });
    },
    del(key) {
      this.yt.editObj.quantities = this.yt.editObj.quantities.filter((item, index) => {
        return index !== key;
      });
    },
    split() {
      let result = this.yt.editObj.quantities.filter(item => item.quantitiesLable > 0).map(item => parseInt(item.quantitiesLable));
      let data = {
        woId: this.yt.editObj.id,
        quantities: result
      };
      return this.http
        .post('/web/production/wo/split', data)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.get();
          this.$message.success(this.$t(res.msg));
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    //导出
    exportExcel() {
      let params = this.yt.conditions;
      params.status = this.yt.conditions.statusList;
      params.equipmentId = this.yt.conditions.equipmentIdList;
      params.materialId = this.yt.conditions.materialIdList;
      params.mouldId = this.yt.conditions.mouldIdList;
      params.startTimeStart = this.yt.conditions.planStartTime;
      params.startTimeEnd = this.yt.conditions.planEndTime;
      if(this.yt.conditions.manufacturingProcessList && this.yt.conditions.manufacturingProcessList.length > 0){
        params.manufacturingProcess = this.yt.conditions.manufacturingProcessList;
      }else {
        params.manufacturingProcess = ['02','03','04'];
      }

      delete params.statusList;
      delete params.equipmentIdList;
      delete params.materialIdList;
      delete params.materialIdList;
      delete params.planStartTime;
      delete params.planEndTime;
      delete params.orderBy;
      this.yt.exportLoading = true;
      return this.http
        .get('/web/report/export/production_wo_report', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.yt.conditions = {
            statusList: ['2', '3', '4', '5'],
            orderBy: 'planStartTime,equipmentId asc'
          };
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.yt.exportLoading = false;
        });
    },
    // 重置
    clear() {
      this.yt.conditions = {
        createTimeStart: this.begin(),
        createTimeEnd: this.end()
      };
      this.yt.list = [];
    },
    singleAdjustListChange(list) {
      this.singleAdjustList = list;
    },
    batchSetPriority() {
      let list = this.$refs.singleAdjust.yt.list;
      if (list == null || list.length === 0) {
        return;
      }
      this.yt.editObj.loading = true;
      // let params = {};
      // list.forEach((l) => {
      //   params[l.id] = l.priority;
      // });

      this.http
        .post('/custom/qunlong/first/inspection/batchSetPriority', list)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.editObj.loading = false;
          this.yt.get();
          this.$message.success(this.$t(res.msg));
        })
        .catch(e => {
          this.yt.editObj.loading = false;
          this.utils.errorMessage(e);
        });
    },

    getAdaptMould() {
      //获取机模配磨具
      let params = {};
      this.adaptMoulds = [];
      params.materialId = this.yt.editObj.materialId;
      params.pageSize = 999;
      this.http
        .get('/web/basic/mould/adaptMould', {
          params: params
        })
        .then(res => {
          this.adaptMoulds = res.data.rows;
        })
        .catch(err => {
          this.utils.errorMessage(err);
        });
    },
    getAdaptEquipment() {
      //获取机模配机器
      let params = {};
      params.materialId = this.yt.editObj.materialId;
      params.mouldId = this.yt.editObj.mouldId;
      params.pageSize = 999;

      this.http
        .get('/web/equipment/adaptEquipmentAllot', {
          params: params
        })
        .then(res => {
          this.adaptEqs = res.data.rows;
        })
        .catch(err => {
          this.utils.errorMessage(err);
        });
    },

    resetAdapData() {
      this.adaptEqs = [];
      this.adaptMoulds = [];
      setTimeout(() => {
        console.log(111);
        this.$refs.eqCS.showDialog(true);
        console.log(222);
      }, 300);
    },

    //ids，items如果是多选会是数组
    async beforeSave(ids, items) {
      console.log(items);
      let params = {
        woIds: ids
      };
      console.log(this);
      try {
        let result = await this.http.post('/custom/qunlong/batchAllotValidated', params);

        this.$set(this.yt.editObj, 'equipmentId', result.data.equipmentId);
        this.$set(this.yt.editObj, 'planQuantity', result.data.planQuantity);
        this.$set(this.yt.editObj, 'leftProductionQuantity', result.data.leftProductionQuantity);
        this.$set(this.yt.editObj, 'materialId', result.data.materialId);
        this.$set(this.yt.editObj, 'mouldId', result.data.mouldId);
        this.$set(this.yt.editObj, 'materialStr', items[0].material.code + '|' + items[0].material.name);
        this.$set(this.yt.editObj, 'woIds', result.data.woIds);

        this.getAdaptMould();
        this.getAdaptEquipment();

        return true;
      } catch (error) {
        this.utils.errorMessage(error);
        return false;
      }
    },
    weierPrintSilkLabel(wo) {
      this.printObj = this.utils.copy(wo);
      this.isShowWeierPrintSilkLabel = true;
    },
    closeWeierPrintSilkLabel() {
      this.isShowWeierPrintSilkLabel = false;
    },
    weierPrintAssembleLabel(wo) {
      this.printObj = this.utils.copy(wo);
      this.isShowWeierPrintAssembleLabel = true;
    },
    closeWeierPrintAssembleLabel() {
      this.isShowWeierPrintAssembleLabel = false;
    },
    weierPrintProcessLabel(wo) {
      this.printObj = this.utils.copy(wo);
      this.isShowWeierPrintProcessLabel = true;
    },
    closeWeierPrintProcessLabel() {
      this.isShowWeierPrintProcessLabel = false;
    },
    weierAdaptTool(wo) {
      this.$set(this,'material', wo.material);
      this.isShowWeierAdaptTool = true;
    },
    childWoCheck(row){
      let params = {};
      params.id = row.id;
      this.loading = true;
      this.http.post('/web/production/wo/check', params).then(res => {
        this.loading = false;
        if (res.data == true) {
          this.childStart(row);
        } else {
          this.$confirm(this.$t('cunzaizantinggongdandetishi'), this.$t('tishi'), {
            confirmButtonText: this.$t('rengjixukaishi'),
            cancelButtonText: this.$t('quxiaokaishi'),
            type: 'warning'
          }).then(() => {
            this.childStart(row);
          }).catch(() => { });
        }
      }).catch(err => {
        this.loading = false;
        this.utils.errorMessage(err);
      });
    },
    childStart(row){
      this.http.post('/web/production/wo/childStart', row.id).then(res => {
        this.yt.get();
        this.$message.success(this.$t(res.msg));
      }).catch(error => {
        this.$message.error(this.$t(error));
      });
    },
    childStop(row) {
      this.$set(row, 'stopLoading', true);
      this.http.post('/web/production/wo/childStopCheck', row.id).then(res => {
        if (res.data && res.data > 0) {
          this.$confirm(this.$t('dqkhmcs') + res.data + ',' + this.$t('qqrsfjxzt') + '?', this.$t('tishi'), {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.http.post('/web/production/wo/childStop', row.id).then(res => {
              this.yt.get();
              this.$message.success(this.$t(res.msg));
            }).catch(error => {
              this.$message.error(this.$t(error));
            });
          });
        } else {
          this.http.post('/web/production/wo/childStop', row.id).then(res => {
            this.yt.get();
            this.$message.success(this.$t(res.msg));
          }).catch(error => {
            this.$message.error(this.$t(error));
          });
        }
      }).catch(error => {
        this.$message.error(this.$t(error));
      }).finally(() => {
        this.$set(row, 'stopLoading', false);
      });
    },
  }
};
</script>
